"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = void 0;
exports.refinementsSetData = refinementsSetData;
exports.refinementsSetFilter = refinementsSetFilter;
const Actions = __importStar(require("../actions/types"));
const State = __importStar(require("../state"));
exports.DEFAULT = {
    refinementsFilter: State.AvailableRefinementType.All,
    data: {
        categoryIds: [],
        classIds: [],
        actualAttributes: [],
    },
    isLoading: false,
};
function refinementsSetData(state, { payload: { refinements } }) {
    return Object.assign(Object.assign({}, state), { data: refinements });
}
function refinementsSetFilter(state, { payload: { type } }) {
    return Object.assign(Object.assign({}, state), { refinementsFilter: type });
}
exports.default = (state = exports.DEFAULT, action) => {
    switch (action.type) {
        case Actions.REFINEMENTS_SET_FILTER:
            return refinementsSetFilter(state, action);
        case Actions.REFINEMENTS_SET_DATA:
            return refinementsSetData(state, action);
        case Actions.REFINEMENTS_SET_LOADING:
            return Object.assign(Object.assign({}, state), { isLoading: action.payload });
        case Actions.RESET:
            return exports.DEFAULT;
        default:
            return state;
    }
};
